// API utility functions

const PROD_API_BASE = 'https://beemerce-prod.v1cc0.workers.dev';
const STAGING_API_BASE = 'https://beemerce-stg.v1cc0.workers.dev';
const LEGACY_API_BASE = 'https://beemerce.v1cc0.workers.dev';

const resolveRuntimeApiBase = (): string => {
  if (typeof window === 'undefined') {
    return PROD_API_BASE;
  }

  const host = window.location.hostname.toLowerCase();

  if (host.includes('beemerce-stg')) {
    return STAGING_API_BASE;
  }

  if (host.includes('beemerce-prod')) {
    return PROD_API_BASE;
  }

  if (host.includes('beemerce-frontend')) {
    return LEGACY_API_BASE;
  }

  return PROD_API_BASE;
};

export const getApiBaseUrl = (): string => {
  if (import.meta.env.DEV) {
    return '';
  }

  const envApiBase = import.meta.env.VITE_API_BASE?.trim();
  if (envApiBase) {
    return envApiBase.replace(/\/$/, '');
  }

  return resolveRuntimeApiBase();
};

export const apiUrl = (path: string): string => {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${path}`;
};
